import * as yup from 'yup';
import { isMobilePhone, isPhoneNumber } from 'class-validator';

type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialEstablishmentDetailsDto = {
  name: undefined,
  siret: undefined,
  enterpriseId: undefined,
  email: undefined,
  activityAreaIds: [],
  mobilePhone: undefined,
  phone: undefined,
  creditsAlertThreshold: undefined,
};

export const establishmentDetailsDtoSchema = (translate: TFunction) => {
  return yup.object().shape({
    name: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      })
      .min(2, translate(translate('MIN_CHAR').replace('{var}', '2')))
      .max(50, translate(translate('MAX_CHAR').replace('{var}', '50'))),
    siret: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .matches(/^\d{14}$/, translate('SIRET_MAX')),
    enterpriseId: yup.string().required(translate('REQUIRED') ?? undefined),
    email: yup
      .string()
      .required(translate('REQUIRED'))
      .nullable()
      .email(translate('INVALID_EMAIL_FORMAT') ?? undefined),
    activityAreaIds: yup
      .array()
      .min(1, translate('REQUIRED') ?? undefined)
      .required(translate('REQUIRED') ?? undefined),
    phone: yup
      .string()
      .required(translate('REQUIRED'))
      .nullable()
      .test(
        'INAVLID_PHONE_NUMBER',
        translate('INAVLID_PHONE_NUMBER'),
        (value) => {
          // Use a custom test to check if the value contains only spaces

          if (value === null) return false;
          if (!value) return true;
          return isPhoneNumber(value);
        },
      ),
    mobilePhone: yup
      .string()
      .optional()
      .nullable()
      .test(
        'INAVLID_PHONE_NUMBER',
        translate('INAVLID_PHONE_NUMBER'),
        (value) => {
          // Use a custom test to check if the value contains only spaces
          if (value === undefined) return true;

          if (!value) return true;
          return isMobilePhone(value);
        },
      ),
    creditsAlertThreshold: yup.string().required(translate('REQUIRED')),
  });
};
